import React, { useState, useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'

import Sidebar from '../layouts/Sidebar'
import Tabs from '../components/ui/Tabs'
import AnnouncementService from "../services/AnnouncementService"
import getSocket from "../services/socket"


function Announcement() {

    // Announcements
    const [announcements, setAnnouncements] = useState([]);
    const [drills, setDrills] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const loadAnnouncements = async () => {
        try {
            let response = await AnnouncementService.findAll(1, 100);
            if (response && response.status === 200) {
                setDrills(response.data.filter(({drill})=>drill==true));
                setAnnouncements(response.data.filter(({drill})=>drill==false));
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadAnnouncements();
    }, [location.pathname]);

    // Live upsert on any incident create/update/activate/close/reject — see server
    // src/realtime/emit.js emitIncidentUpdate — instead of relying on a manual refresh.
    useEffect(() => {
        const socket = getSocket();
        const upsert = (list, incoming) => {
            const idx = list.findIndex((a) => a.id === incoming.id);
            if (idx === -1) return [incoming, ...list];
            const next = [...list];
            next[idx] = incoming;
            return next;
        };
        const onIncidentUpdate = (incident) => {
            if (incident.drill) {
                setDrills((prev) => upsert(prev, incident));
            } else {
                setAnnouncements((prev) => upsert(prev, incident));
            }
        };
        socket.on('incident:update', onIncidentUpdate);
        return () => socket.off('incident:update', onIncidentUpdate);
    }, []);

    const activeTab = location.pathname.endsWith('/drills') ? 'drills' : 'announcements';

    const Header = () => (
        <Tabs
            tabs={[
                { value: 'announcements', label: 'Announcements' },
                { value: 'drills', label: 'Drills' },
            ]}
            active={activeTab}
            onChange={(value) => navigate(value === 'drills' ? 'drills' : '')}
        />
    );

    return (
        <Sidebar title="Announcements" header={<Header />}>
            <Outlet context={[announcements, drills, loading]}/>
        </Sidebar>
    )
}

export default Announcement
